import { useCallback, useEffect, useRef, useState } from 'react';

const ONE_SECOND_IN_MS = 1000;
const THIRTY_MINUTES_IN_MS = 30 * 60 * 1000;

export function useIdleTimer({
  events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'],
  interval = ONE_SECOND_IN_MS,
  timeout = THIRTY_MINUTES_IN_MS,
}) {
  const timeLeftRef = useRef(timeout);
  const [idle, setIdle] = useState(false);

  const tick = () => {
    if (idle) {
      return;
    }

    const remaining = timeLeftRef.current - interval;
    timeLeftRef.current = remaining <= 0 ? 0 : remaining;
    setIdle(remaining <= 0);
  };

  const reset = useCallback(() => {
    if (idle) {
      return;
    }

    timeLeftRef.current = timeout;
    setIdle(false);
  }, [timeout, idle]);

  useEffect(() => {
    if (timeout <= 0) {
      return;
    }

    events.forEach(evt => window.addEventListener(evt, reset));
    const countdown = setInterval(tick, interval);

    return () => {
      events.forEach(evt => window.removeEventListener(evt, reset));
      clearInterval(countdown);
    };
  });

  return {
    idle,
    reset,
  };
}
